import { render, staticRenderFns } from "./EditDestino.vue?vue&type=template&id=0d2ff268&scoped=true"
import script from "./EditDestino.vue?vue&type=script&lang=js"
export * from "./EditDestino.vue?vue&type=script&lang=js"
import style0 from "./EditDestino.vue?vue&type=style&index=0&id=0d2ff268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2ff268",
  null
  
)

export default component.exports